export const formatNumeric = (text = ""): string | undefined =>
  text.length ? text.replace(/[^\d]/g, "") : undefined;

export const formatAlphabetic = (text = ""): string | undefined => {
  if (text[0] === " ") {
    return "";
  }

  return text.length ? text.replace(/[^A-Za-zğüşıöçĞÜŞİÖÇ ]+/g, "") : undefined;
};

export const formatAlphaNumeric = (text = ""): string | undefined => {
  if (text[0] === " ") {
    return "";
  }

  return text.length ? text.replace(/[^A-Za-z0-9]/g, "") : undefined;
};

export const formatMail = (text = ""): string | undefined => {
  if (text[0] === " ") {
    return "";
  }

  return text.length
    ? text.replace(/[^a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]/g, "")
    : undefined;
};

export const formatOrderId = (text = ""): string | undefined => {
  if (text[0] === " ") {
    return undefined;
  }

  return text.length ? text.trim().replace(/[^a-zA-Z0-9\s-]+/g, "") : undefined;
};

export const formatxid = (text = ""): string | undefined => {
  if (text[0] === " ") {
    return undefined;
  }

  return text.length
    ? text.trim().replace(/[^a-zA-Z0-9\s-=]+/g, "")
    : undefined;
};

export const formatIp = (text = ""): string | undefined => {
  return text.length ? text.trim().replace(/[^0-9\s.]+/g, "") : undefined;
};

export const clearForeignCharacters = (text = ""): string => {
  return text.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "");
};

export const convertMaskCardNumber = (number = ""): string => {
  const maskedCard = `${number.substring(0, 6)}${"*".repeat(
    number.length - 4 - 6
  )}${number.substring(number.length - 4, number.length)}`;

  return maskedCard;
};

export const formatPhoneNumber = (text = ""): string => {
  const phoneNumber = text
    .replace(/\D/g, "")
    .match(/(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/);

  if (phoneNumber && text?.length) {
    if (phoneNumber[0] === "0") {
      return "";
    }

    return !phoneNumber[2]
      ? phoneNumber[1].replace(phoneNumber[1][0], "5")
      : `(${phoneNumber[1]}) ${phoneNumber[2]}${
          phoneNumber[3] ? ` ${phoneNumber[3]}` : ""
        }${phoneNumber[4] ? ` ${phoneNumber[4]}` : ""}`;
  }

  return text;
};

export const formatLandPhoneNumber = (text = ""): string => {
  const phoneNumber = text
    .replace(/\D/g, "")
    .match(/(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/);

  if (phoneNumber && text?.length) {
    if (phoneNumber[0] === "0") {
      return "";
    }

    return !phoneNumber[2]
      ? phoneNumber[1]
      : `(${phoneNumber[1]}) ${phoneNumber[2]}${
          phoneNumber[3] ? ` ${phoneNumber[3]}` : ""
        }${phoneNumber[4] ? ` ${phoneNumber[4]}` : ""}`;
  }

  return text;
};

export const convertNumber = (text = ""): number => {
  if (text.length) {
    return parseFloat(text);
  }

  return -1;
};

export const initialsFromName = (fullName = ""): string => {
  const firstChar = fullName
    .split(" ")
    .map((word) => (word.charAt(0) !== "*" ? word.charAt(0) : ""))
    .join(" ");

  return firstChar;
};

export const maxName = (character = ""): string => {
  const firstChar = character.length > 5 ? character.substr(0, 5) : character;

  return firstChar;
};

export const maxUserName = (character = "", charLen = 17): string => {
  const firstChar =
    character.length > charLen
      ? `${character.substr(0, charLen)}...`
      : character;

  return firstChar;
};

export const formattingUserName = (character = ""): string => {
  const characterSplit = character.split(" ");
  const term =
    characterSplit?.length > 2
      ? `${characterSplit[0]} ${characterSplit[characterSplit.length - 1]}`
      : character;

  return term;
};

export const creditCardCheckLuhn = (cardNo = ""): boolean => {
  let digitSummary = 0;
  let isSecond = false;

  for (let i = cardNo.length - 1; i >= 0; i -= 1) {
    let digit = cardNo[i].charCodeAt(0) - "0".charCodeAt(0);

    if (isSecond === true) digit *= 2;

    digitSummary += parseInt(`${digit / 10}`, 10);
    digitSummary += digit % 10;

    isSecond = !isSecond;
  }

  return digitSummary % 10 === 0;
};

export const checkTckn = (value: string): boolean => {
  const isEleven = value.length === 11;
  let totalX = 0;
  for (let i = 0; i < 10; i += 1) {
    totalX += convertNumber(value[i]);
  }

  const isRuleX = totalX % 10 === convertNumber(value[10]);
  let totalY1 = 0;
  let totalY2 = 0;
  for (let i = 0; i < 10; i += 2) {
    totalY1 += convertNumber(value[i]);
  }
  for (let i = 1; i < 9; i += 2) {
    totalY2 += convertNumber(value[i]);
  }

  const isRuleY = (totalY1 * 7 - totalY2) % 10 === convertNumber(value[9]);

  return isEleven && isRuleX && isRuleY;
};

export const checkVkn = (value: string): boolean => {
  const v = [];
  const lastDigit = Number(value.charAt(9));
  for (let i = 0; i < 9; i += 1) {
    const tmp = (Number(value.charAt(i)) + (9 - i)) % 10;
    v[i] = (tmp * 2 ** (9 - i)) % 9;
    if (tmp !== 0 && v[i] === 0) v[i] = 9;
  }
  const sum = v.reduce((a, b) => a + b, 0) % 10;

  return (10 - (sum % 10)) % 10 === lastDigit;
};

export const formatInstallment = (installment: number): number | string => {
  if (installment === 1) {
    return "Peşin";
  }

  return installment;
};

export const removeSpace = (text = ""): string => {
  if (text.length) {
    return text.replace(/ +/g, "");
  }

  return "";
};

export const isNumeric = (text: string | undefined): boolean => {
  if (text) {
    return /^\d+$/.test(text);
  }
  return false;
};

export const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

export const convertMaskedString = (text = ""): string => {
  if (text.length <= 2) {
    return text;
  }
  const masked =
    text.substring(0, text.length - 2).replace(/[a-z\d]/gi, "*") +
    text.substring(text.length - 2, text.length);
  return masked;
};

export const maskedString = (s: string) => {
  if (!s || s.length === 0) return "";
  return s
    .split(" ")
    .map((word) => word.replace(/(?<=..).(?=)/g, "*"))
    .join(" ");
};

export const eachFirstLetterCapital = (s: string) => {
  if (s.length === 0) return "";
  const arr = s.split(" ");
  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  return arr.join(" ");
};

export const formatPhoneNumberView = (s: string) => {
  if (s.length !== 10) return "-1";
  s = s.startsWith("0") ? s.substring(1, s.length) : s;
  const pn = `
  ${s.substr(0, 3)} ${s.substr(3, 3)} ${s.substr(6, 2)} ${s.substr(8, 2)}
  `;
  return pn;
};
